import { DocumentInformation } from '@shared/types'
import { base64ToBlob } from '@ui-common/utils/helpers'
import { setIsExternalNavigation } from '@ui-components/utilities/navigation'

export const downloadAndOpenBase64 = ({
  base64Encoded,
  documentInformation,
}: {
  base64Encoded: string
  documentInformation: DocumentInformation
}): void => {
  const { mimeType, fileName } = documentInformation
  const blob = base64ToBlob(base64Encoded, mimeType)
  const linkSource = URL.createObjectURL(blob)
  const downloadLink = document.createElement('a')
  downloadLink.href = linkSource
  downloadLink.download = fileName
  downloadLink.click()
}

export const downloadSignedUrl = (signedUrl: string): void => {
  const link = document.createElement('a')
  link.href = signedUrl
  link.download = ''
  setIsExternalNavigation(true)
  link.click()
  setTimeout(() => {
    setIsExternalNavigation(false)
  }, 500)
}
